import src from "IMAGE";
export default { src, width: 903, height: 561, blurWidth: 0, blurHeight: 0};
